import { twMerge } from "tailwind-merge";

export default function ToolsPageSectionLabel({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={twMerge(
        "text-[18px] font-light md:text-[20px] text-black pb-[10px] border border-solid border-x-0 border-t-0 mb-[20px] border-b border-b-inactive-gray",
        className
      )}
    >
      {children}
    </div>
  );
}
